import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=6e41b4fc&scoped=true"
import script from "./notice.vue?vue&type=script&lang=ts"
export * from "./notice.vue?vue&type=script&lang=ts"
import style0 from "./notice.vue?vue&type=style&index=0&id=6e41b4fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e41b4fc",
  null
  
)

export default component.exports